import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpClientSecured } from '../services/http-client-secured';
import { Observable, throwError } from 'rxjs';
import { IRol } from './rol';
import { catchError, tap, map } from 'rxjs/operators';
import * as myGlobals from './../global';
import { RolePermissions } from '../menu/role.permissions.model';

@Injectable({
  providedIn: 'root'
})
export class RolesService {
  private _rolesURL = myGlobals.baseApi + '/webadmin/v1/roles';
  private _rolePermissionsURL = myGlobals.baseApi + '/webadmin/v1/role/'; // 50/rolePermissions';
  private _updateRolePermissionsURL = myGlobals.baseApi + '/webadmin/v1/role/'; // 50/rolePermissions';
  private _activeURL = myGlobals.baseApi + '/webadmin/v1/roles';

  constructor(private http: HttpClientSecured) {}

  getRoles() {
    return this.http.get<any>(this._rolesURL);
  }

  getRol(id: number): Observable<IRol | undefined> {
    return this.getRoles().pipe(map((roles: IRol[]) => roles.find(p => p.id === id)));
  }

  getActiveRoles(): Observable<IRol[]> {
    // The endpoint returns every role; active is status 1 (see roles.component.html).
    return this.http.get<IRol[]>(this._activeURL).pipe(
      map((roles: IRol[]) => roles.filter(rol => rol.status === 1)),
      catchError(this.handleError)
    );
  }

  getRolePermissions(roleId: number): Observable<RolePermissions> {
    return this.http.get<RolePermissions>(this._rolePermissionsURL + roleId + '/rolePermissions').pipe(
      tap(data => console.log('getRolePermissions: ' + JSON.stringify(data))),
      catchError(this.handleError)
    );
  }

  updateRolePermissions(roleId: number, rolePermissions: RolePermissions): Observable<void> {
    return this.http.put<void>(this._updateRolePermissionsURL + roleId + '/rolePermissions', rolePermissions);
  }
ƒ
  private handleError(err: HttpErrorResponse) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
